module.exports = __webpack_public_path__ + "img/zsgscl-3.355e0940.jpg";